// extracted by mini-css-extract-plugin
module.exports = {"spacer":"DisclaimerSpacerBlock_spacer__b7O6s"};